import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    card: {
        justifyContent: "center",
        alignItems: "center",
        minWidth: "30%",
        borderWidth: 1
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    textSpacing: {
        textAlign: "center"
    }
});
export default stylesheet;
